<template>
  <b-input-group>
    <b-form-input
      :id="id"
      ref="baseInput"
      :type="inputType"
      @input="handleInput"
      v-model="password"
      :state="state"
      :required="required"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
    />
    
    <b-input-group-append
      class="toggler"
      @click="togglePasswordVisiblity"
      is-text
    >
      <b-icon :icon="icon" />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  name: 'PasswordInput',

  props: {
    value: String,

    id: {
      type: String,
    },

    autofocus: {
      type: Boolean,
      default: false,
    },

    state: {
      type: Boolean,
      default: null,
    },

    required: {
      type: Boolean,
      default: false,
    },

    maxlength: {
      type: Number,
    },

    autocomplete: {
      type: String
    }
  },

  computed: {
    inputType() {
      return this.passwordVisible ? 'text' : 'password';
    },

    icon() {
      return this.passwordVisible ? 'eye-slash' : 'eye';
    },
  },
  
  data() {
    return {
      password: this.value,
      passwordVisible: false,
    };
  },

  methods: {
    handleInput() {
      this.$emit('input', this.password);
    },

    togglePasswordVisiblity() {
      this.passwordVisible = !this.passwordVisible;
    },

    focus() {
      this.$refs.baseInput.focus();
    },
  },
};
</script>

<style scoped>
.toggler {
  cursor: pointer;
}
</style>
